import { jsx } from 'react/jsx-runtime';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const APP_SOTRE_ICON_WIDTH = 100;
const APP_SOTRE_ICON_HEIGHT = 30;

const appStoreConfigMap = {
    apple: {
        alt: '  Apple app store icon',
        height: APP_SOTRE_ICON_HEIGHT,
        imgSrc: 'https://i.i-sgcm.com/all/icon_ap.png',
        url: 'https://itunes.apple.com/us/app/sgcarmart/id962261200?mt=8',
        width: APP_SOTRE_ICON_WIDTH,
    },
    google: {
        alt: 'Google play store icon',
        height: APP_SOTRE_ICON_HEIGHT,
        imgSrc: 'https://i.i-sgcm.com/all/icon_pl.png',
        url: 'https://play.google.com/store/apps/details?id=com.sgcarmart.app',
        width: APP_SOTRE_ICON_WIDTH,
    },
    huawei: {
        alt: 'Huawei store icon',
        height: APP_SOTRE_ICON_HEIGHT,
        imgSrc: 'https://i.i-sgcm.com/all/icon_huawei.png',
        url: 'https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C101183615?detailType=0&subsource=&referrer=&s=&shareFrom=&v=&shareTo=&source=&id=&locale=&channelId=web',
        width: APP_SOTRE_ICON_WIDTH,
    },
};

var css_248z = ".SGCM_UIKIT_NEXT_AppStoreList_listAppStore_1dl7h_1 {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  column-gap: 6px;\n  list-style-type: none;\n}\n\n.SGCM_UIKIT_NEXT_AppStoreList_linkAppStore_1dl7h_9 {\n  display: block;\n  line-height: 0;\n}\n\n.SGCM_UIKIT_NEXT_AppStoreList_imgAppStore_1dl7h_14 {\n  height: auto;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixVQUFVO0VBQ1YsU0FBUztFQUNULGVBQWU7RUFDZixxQkFBcUI7QUFDdkI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QsY0FBYztBQUNoQjs7QUFFQTtFQUNFLFlBQVk7QUFDZCIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubGlzdEFwcFN0b3JlIHtcbiAgZGlzcGxheTogZmxleDtcbiAgcGFkZGluZzogMDtcbiAgbWFyZ2luOiAwO1xuICBjb2x1bW4tZ2FwOiA2cHg7XG4gIGxpc3Qtc3R5bGUtdHlwZTogbm9uZTtcbn1cblxuLmxpbmtBcHBTdG9yZSB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBsaW5lLWhlaWdodDogMDtcbn1cblxuLmltZ0FwcFN0b3JlIHtcbiAgaGVpZ2h0OiBhdXRvO1xufSJdfQ== */";
var styles = {"listAppStore":"SGCM_UIKIT_NEXT_AppStoreList_listAppStore_1dl7h_1","linkAppStore":"SGCM_UIKIT_NEXT_AppStoreList_linkAppStore_1dl7h_9","imgAppStore":"SGCM_UIKIT_NEXT_AppStoreList_imgAppStore_1dl7h_14"};
styleInject(css_248z);

const AppStoreList = () => (jsx("ul", { className: styles.listAppStore, children: Object.entries(appStoreConfigMap)
        .map(([appStore, { url, imgSrc, alt, width, height, }]) => (jsx("li", { children: jsx("a", { className: styles.linkAppStore, href: url, children: jsx("img", { alt: alt, className: styles.imgAppStore, height: height, src: imgSrc, width: width }) }) }, appStore))) }));

export { AppStoreList as A };
//# sourceMappingURL=component-CULKTR34.js.map
